import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/layout/AppLayout";

import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Upload from "@/pages/Upload";
import Builder from "@/pages/Builder";
import Organizer from "@/pages/Organizer";
import Editor from "@/pages/Editor";
import Templates from "@/pages/Templates";
import Settings from "@/pages/Settings";
import Users from "@/pages/Users";
import Print from "@/pages/Print";
import JobProfiles from "@/pages/JobProfiles";
import ClientSubmissions from "@/pages/ClientSubmissions";
import EmailCenter from "@/pages/EmailCenter";
import Reports from "@/pages/Reports";
import Clients from "@/pages/Clients";
import Documents from "@/pages/Documents";
import Interviews from "@/pages/Interviews";
import Careers from "@/pages/Careers";
import Plans from "@/pages/Plans";
import Companies from "@/pages/Companies";

function Shell({ children, roles }) {
  return (
    <ProtectedRoute roles={roles}>
      <AppLayout>{children}</AppLayout>
    </ProtectedRoute>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/" element={<Shell><Dashboard /></Shell>} />
              <Route path="/upload" element={<Shell><Upload /></Shell>} />
              <Route path="/builder" element={<Shell><Builder /></Shell>} />
              <Route path="/organizer" element={<Shell><Organizer /></Shell>} />
              <Route path="/job-profiles" element={<Shell><JobProfiles /></Shell>} />
              <Route path="/clients" element={<Shell><Clients /></Shell>} />
              <Route path="/documents" element={<Shell><Documents /></Shell>} />
              <Route path="/interviews" element={<Shell><Interviews /></Shell>} />
              <Route path="/submissions" element={<Shell><ClientSubmissions /></Shell>} />
              <Route path="/email-center" element={<Shell roles={["super_admin", "company_admin"]}><EmailCenter /></Shell>} />
              <Route path="/reports" element={<Shell><Reports /></Shell>} />
              <Route path="/editor/:id" element={<ProtectedRoute><Editor /></ProtectedRoute>} />
              <Route path="/templates" element={<Shell><Templates /></Shell>} />
              <Route path="/users" element={<Shell roles={["super_admin", "company_admin"]}><Users /></Shell>} />
              <Route path="/plans" element={<Shell><Plans /></Shell>} />
              <Route path="/companies" element={<Shell roles={["super_admin", "company_admin"]}><Companies /></Shell>} />
              <Route path="/settings" element={<Shell><Settings /></Shell>} />
              <Route path="/print/:id" element={<Print />} />
            </Routes>
          </BrowserRouter>
          <Toaster richColors position="top-right" />
        </div>
      </AuthProvider>
    </ThemeProvider>
  );
}
